import { useEffect, useRef } from 'react'
import isEqual from 'react-fast-compare'

type Options = {
  cleanupFn?: () => void,
}

function useDeepEffect(effectFn: () => void, deps: Array<any> = [], options: Options = {}) {
  const { cleanupFn } = options

  const firstRun = useRef(true)
  const prevDeps = useRef(deps)

  useEffect(() => {
    const depsMatch = isEqual(prevDeps.current, deps)

    // Only run if the first run or the deps have changed
    if (firstRun.current || !depsMatch){
      effectFn()
    }

    firstRun.current = false
    prevDeps.current = deps

    return () => {
      if (cleanupFn) cleanupFn()
    }
  }, deps)
}

export default useDeepEffect
